import { Children, lazy, Suspense, useEffect, useState } from "react";
import Loader from "../Theme/loader";
import { Route, Switch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMyMenus } from "../AppRedux/Actions/Auth";
import { routeNames as routes, fixedRoutes } from "../routes";

const Layout = lazy(() => import("../Layout"));
const PageNotFound = lazy(() => import("./pageNotFound"));
// const DefaultComponent = lazy(() => import("./player"));

const MainApp = (props) => {
    const dispatch = useDispatch();
    const { authUser, menus, user } = useSelector(state => state.auth);
    const [menuList, setMenuList] = useState([]);
    useEffect(() => {
        if (authUser) {
            dispatch(getMyMenus(props.history, user));
        }
    }, [authUser]);

    useEffect(() => {
        if (menus) {
            // filtering the menu version
            setMenuList(menus.filter((item) => item.menu_version != 3));
        }
    }, [menus]);

    const renderSubRoutes = (menuList) => {
        return menuList.map(menu => {
            if (menu.children.length > 0 && menu?.menu_version !== 2) {
                return renderSubRoutes(menu.children);
            } else {
                return <Route exact path={menu.url} component={routes[menu.menu_layout] || PageNotFound} />
            }
        })
    }

    return (
        <>
            <Loader />
            <Suspense fallback={<Loader />}>
                <Layout menus={menuList} {...props}>
                    <Switch>
                        {Children.toArray(renderSubRoutes(menuList))}
                        {fixedRoutes?.length > 0 && Children.toArray(
                            fixedRoutes.map(menu => {
                                return <Route exact path={`${menu.url}`} component={routes[menu.menu_layout] || PageNotFound} />
                            })
                        )}
                        {menuList.length > 0 && <Route path={`${props.match.url}`} component={PageNotFound} />}
                    </Switch>
                </Layout>
            </Suspense>
        </>
    );
}
export default MainApp;